import { PaletteColor } from '@mui/material'

declare module '@mui/material/styles' {
	interface Palette {
		gameLeapFrog: Palette['primary']
	}

	interface PaletteOptions {
		gameLeapFrog?: PaletteOptions['primary']
	}
}

declare module '@mui/material/Alert' {
	interface AlertPropsColorOverrides {
		gameLeapFrog: true
	}
}

export const gameLeapFrogColor = {
	main: '#488F4E',
	light: '#E4F4D8',
} as PaletteColor
